// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: true,
    api_cm_resources: '###{api_cm_resources}###',
    api_cm_sow: '###{api_cm_sow}###',
    api_cm_manualtimesheet: '###{api_cm_manualtimesheet}###',
    api_cm_receipts: '###{api_cm_receipts}###',
    api_cm_reports: '###{api_cm_reports}###',
    api_cm_security: '###{api_cm_security}###',

    //oneLogin
    authority: '###{authority}###',
    url_app_login: '###{url_app_login}###',
    client_id_one: '###{client_id_one}###',
    redirec_url: '###{redirec_url}###',
    silent_url_login: '###{silent_url_login}###',
    //key api-subscription
    key_api_subscription: '###{key_api_subscription}###',
    key_api_secret: 'user',
    secureStorage: {
      enabled: '###{activate_encryption}###',  // Set to false to disable secure storage
      encryptionKey: '###{storage_secret}###',
    },

    // Secure-Comm Gateway Configuration
    secureComm: {
      apiBaseUrl: '###{secure_comm_api_base_url}###'
    }
  };

  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
